import { PracticeCourt } from '@/store/modules/common/types';
import { throttle } from 'lodash';
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const commonModel = namespace('common');
@Component
export default class ScrollListen extends Vue {
  @commonModel.State('setyleNavHeight') setyleNavHeight: number;
  @commonModel.State('practiceCourt') practiceCourt!: PracticeCourt;
  scrollListener: () => any;
  currentScrollTop = 0;

  initScrollListen(el: Element) {
    if (!el) return;

    this.scrollListener = throttle(() => {
      if (el.scrollTop < this.setyleNavHeight || el.scrollTop < this.currentScrollTop) {
        this.$PostConnection?.command('nav_show', {
          animation: true
        });
        this.$store.commit('common/setClewordNavVisible', true);
      } else if (el.scrollTop === this.currentScrollTop || this.practiceCourt.visible) {
        // 保持原操作
      } else {
        this.$PostConnection?.command('nav_hide', {
          animation: true
        });
        this.$store.commit('common/setClewordNavVisible', false);
      }
      this.currentScrollTop = el.scrollTop;
    }, 100) as () => any;
    el.addEventListener('scroll', this.scrollListener);
    this.scrollListener();
  }

  destroyScroll(el: Element) {
    if (!el) return;
    el.removeEventListener('scroll', this.scrollListener);
  }
}
